<!-- Crawl功能 -->
<template>
  <div class="CrawlSingular">
    <div
      class="SingularWrap"
      v-loading="previewObj.CrawlLoading">
      <div class="SingularMenu">
        <div class="CrawlBGC" >
          <div>
            <el-checkbox v-if="CrawlBGC" :disabled="CloneDisabled.Crawl||CloneDisabled.disableButton" v-model="setBgc" @change="BgcChange">BG&C</el-checkbox>
            <el-checkbox v-if="CrawlRss" :disabled="CloneDisabled.Crawl||CloneDisabled.disableButton" v-model="rssFlag" @change="rssChange" :class="CrawlFlag?'changeRed':''">RSS <i class="iconfont icon-subscribe"></i></el-checkbox>
          </div>
          <div class="perview" @click="OpenPreview">
            <i class="iconfont icon-preview_btn"></i>
            <span>{{$t('lang.CrawlPerview')}}</span>
          </div>
        </div>
        <iframe
          id="menuDom"
          :src="ShowmenuUrl"
          frameborder="0"
          class="iframe"
        ></iframe>
      </div>
      <el-button :disabled="CloneDisabled.Crawl||CloneDisabled.disableButton" :loading="saveLoading" class="saveBtn" type="success" @click="saveInfo">{{ $t('lang.save') }}</el-button>
    </div>
    <!-- Crawl预览功能 -->
    <crawlPreview v-if="crawlPreview.syncSwitch" :previewObj="crawlPreview" />
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import '@/assets/js/messenger.js'
import { mapState } from 'vuex'
import crawlPreview from './crawlPreview'
export default {
  props: {
    // 开关
    OverlaySwitch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // BG&C开关
      setBgc: false,
      // iframe url
      ShowmenuUrl: '',
      menuUrl: '',
      // 预览信息
      previewObj: {
        syncSwitch: true,
        pvwUrl: '',
        CrawlLoading: true
      },
      childMountedTimer: null,
      saveLoading: false,
      // BG&C功能是否开启
      CrawlBGC: false,
      // feature CrawlRss功能是否开启
      CrawlRss: false,
      // crawl开关是否打开
      CrawlFlag: false,
      // rss开关
      rssFlag: false,
      // crawl预览
      crawlPreview: {
        syncSwitch: false,
        CrawlLoading: true
      }
    }
  },
  components: {
    crawlPreview
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled,
      listFeatures: (state) => state.playout.listFeatures
    })
  },
  watch: {
    syncSwitch (value) {
      if (!value) {
        this.$emit('closeCrawl')
      }
    },
    // 监听中英文
    '$i18n.locale' (value) {
      this.ShowmenuUrl = `${this.menuUrl}&language=${value}`
      this.previewObj.CrawlLoading = true
      this.judgeLoading(1)
    },
    // 监听pgmEnd开关
    listFeatures: {
      handler (val) {
        if (val.includes('CrawlBG&C')) {
          this.CrawlBGC = true
        } else {
          this.CrawlBGC = false
        }
        if (val.includes('CrawlRSS')) {
          this.CrawlRss = true
        } else {
          this.CrawlRss = false
        }
        this.getSwitchStatus()
      },
      immediate: true
    }
  },
  created () {
    Bus.$on('CrawlOnFlag', (flag) => {
      console.log(flag)
      this.CrawlFlag = flag
    })
    this.inquireCrawl()
  },
  mounted () {
    this.getoverlayUrl()
    this.$nextTick(() => {
      const iframe = document.getElementById('menuDom')
      window.messenger = new Messenger('crawlParent', 'crawlMessenger')
      messenger.addTarget(iframe.contentWindow, 'crawlIframe')
      this.childMountedTimer = setInterval(() => {
        if (messenger.targets.crawlIframe) {
          clearInterval(this.childMountedTimer)
          messenger.listen((obj) => {
            obj = JSON.parse(obj)
            if (obj.type == 'checkCrawlName') {
              if (obj.data && !obj.data.isEmpty) {
                this.SavePush()
              } else {
                this.$message.error(this.$t('lang.provideCrawl'))
              }
            } else if (obj.type == 'deleteCrawl') {
              this.checkCrawlUsed(obj)
            }
          })
        }
      }, 1000)
    })
  },
  methods: {
    // 查询Crawl设置信息
    inquireCrawl () {
      this.axios
        .post(Outil.getUrl('/crawl/getCrawl'), {
          entityType: 0,
          entityId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              this.CrawlFlag = !!res.data.result.setOn
            } else {
              this.CrawlFlag = false
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
            this.nativeInfo.CrawlOnFlag = false
          }
        }).catch(() => {})
    },
    saveInfo () {
      // 检查name是否为空
      if (messenger && messenger.targets.crawlIframe) {
        messenger.targets.crawlIframe.send(JSON.stringify({
          type: 'saveCrawl'
        }))
      }
    },
    // 获取iframe的url
    getoverlayUrl () {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/crawl/getOverlayUrl', {
        entityType: 0,
        entityId: this.$BehaviorSyns.getProgramId()
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          // &hotjarCode=2659750
          this.menuUrl = `${res.data.result.menuUrl}`
          this.ShowmenuUrl = `${this.menuUrl}&language=${this.$i18n.locale}`
          this.previewObj.pvwUrl = `${res.data.result.pvwUrl}`
          this.judgeLoading()
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
      this.getSwitchStatus()
    },
    // 获取BGC和RRS状态
    getSwitchStatus () {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/program/BGC/getSwitchStatus').then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (result.setBgc == 2) {
              this.rssFlag = true
              this.setBgc = false
            } else if (result.setBgc == 1) {
              this.setBgc = true
              this.rssFlag = false
            } else {
              this.rssFlag = false
              this.setBgc = false
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 判断iframe是否加载成功
    judgeLoading (type) {
      this.$nextTick(() => {
        const menuDom = document.getElementById('menuDom')
        menuDom.onload = (e) => {
          setTimeout(() => {
            this.previewObj.CrawlLoading = false
          }, 1000)
        }
      })
      if (type) return
      const previewObj = JSON.parse(JSON.stringify(this.previewObj))
      if (!this.crawlPreview.syncSwitch) {
        this.crawlPreview = previewObj
      }
    },
    // 检查crawl是否在使用
    checkCrawlUsed (obj) {
      const programId = this.$BehaviorSyns.getProgramId()
      this.axios.post(Outil.getUrl('/crawl/checkCrawlUsed'), {
        programId: programId,
        contextId: obj.id
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result || {}
          const programTemplates = result.programTemplates ? result.programTemplates.length : 0
          const scheduleTemplates = result.scheduleTemplates ? result.scheduleTemplates.length : 0
          const secondaryEvents = result.secondaryEvents ? result.secondaryEvents.length : 0
          if (programTemplates + scheduleTemplates + secondaryEvents) {
            this.$emit('ShowUsageDetails', result)
          } else {
            if (messenger && messenger.targets.crawlIframe) {
              messenger.targets.crawlIframe.send(JSON.stringify({
                type: 'deleteCrawl',
                isDelete: true
              }))
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 打开预览
    OpenPreview () {
      const previewObj = JSON.parse(JSON.stringify(this.previewObj))
      previewObj.syncSwitch = true
      previewObj.CrawlLoading = true
      if (!this.crawlPreview.syncSwitch) {
        this.crawlPreview = previewObj
      }
    },
    // 关闭弹窗
    cancel () {
      this.$emit('closeCrawl')
    },
    // rss切换
    rssChange () {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/program/RSS/switch', {
        programId: this.$BehaviorSyns.getProgramId(),
        setRss: this.rssFlag ? 2 : 0
      }).then((res) => {
        if (res.data.errorCode !== '0x0') {
          this.rssFlag = !this.rssFlag
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {
        this.rssFlag = !this.rssFlag
      })
    },
    // Bgc发生变化就调接口
    BgcChange () {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/program/BGC/switch', {
        setBgc: this.setBgc ? 1 : 0
      }).then((res) => {
        if (res.data.errorCode !== '0x0') {
          this.setBgc = !this.setBgc
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {
        this.setBgc = !this.setBgc
      })
    },
    // 检查name是否为空
    CheckIsEmpty () {
      if (messenger && messenger.targets.crawlIframe) {
        messenger.targets.crawlIframe.send(JSON.stringify({
          type: 'saveCrawl'
        }))
      }
    },
    // 发送改动到r
    SavePush () {
      this.$confirm(this.$t('lang.ifSaveCrawl'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.close')
      }).then(() => {
        this.saveLoading = true
        this.axios.post('/gatewayPlayoutUrl/tvu-playout/crawl/applyChanges', {
          entityType: 0,
          entityId: this.$BehaviorSyns.getProgramId()
        }).then((res2) => {
          if (res2.data.errorCode == '0x0') {
            this.saveLoading = false
            this.$emit('closeCrawl')
          } else {
            this.saveLoading = false
            const errorInfo = this.$t(toTips[res2.data.errorCode]) || res2.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      })
    }
  },
  beforeDestroy () {
    this.previewObj = {
      syncSwitch: false,
      pvwUrl: '',
      CrawlLoading: false
    }
    if (this.childMountedTimer) clearInterval(this.childMountedTimer)
    messenger.clear()
  }
}
</script>

<style scoped lang="less">
.CrawlSingular {
  height: 100%;
  background: #252525;
  .saveBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  .SingularWrap {
    height: calc(100% - 35px);
    .SingularMenu {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      background: #252525;
      .CrawlBGC{
        margin:13px 15px 0 15px;
        display: flex;
        justify-content: space-between;
        .changeRed{
          ::v-deep .el-checkbox__label{
            color: #E56464;
          }
        }
        .perview {
          color: #DBDBDB;
          i{
            font-size: 12px;
            margin-right: 5px;
          }
        }
        ::v-deep.el-checkbox__label{
          color: #DBDBDB;
        }
        ::v-deep.el-checkbox__inner{
          background: #333333;
          border: 1px solid #666666;
        }
      }
      .iframe {
        width: fit-content;
        height: 500px;
      }
    }
    .SingularPreview {
      .Preview {
        width: 643px;
        height: 367px;
        background: #000000;
      }
      .Operation {
        display: flex;
        justify-content: flex-end;
        margin-top: 100px;
        .el-button {
          width: 100px;
          height: 36px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .Cancel {
          background: #cccccc;
        }
        .Save {
          background: #00cc66;
          border: 1px solid #0f620a;
        }
      }
    }
  }
}
</style>
